import type { ContentType, Distribution } from "./content";
import type {
	OriginalItemTypes,
	RenderableItemTypes,
} from "./session/new-session";

type Content = {
	id: string;
	type: ContentType;
	distribution: Distribution;
	totalCount: number;
	collectionId?: number;
	collectionType?: string;
	isPremium?: boolean | null;
};

export type DisplayType = ["Filter" | "Progress" | "Display"];
export type Item = {
	id: number;
	type: "flashcard" | "question";
	distribution: keyof Distribution;
	variant?: OriginalItemTypes | RenderableItemTypes;
	stats?: {
		score: number;
	} | null;
};
interface MixedItemTag {
	id: string;
	title: string;
	type: string;
	label?: string;
	displayType?: DisplayType;
	distribution: Distribution;
	distributionKey?: string;
	locked?: boolean;
	childTags?: MixedItemTag[];
	children?: MixedItemTag[];
	weight?: number;
	items?: Item[];
	numItems?: number;
	numCorrect?: number;
	numIncorrect?: number;
	numSkipped?: number;
	score?: number;
	averageScore?: number;
	numTotalPoints?: number;
	numPointsEarned?: number;
	code?: string | null;
	icon?: string | null;
	examName?: string;
}

type LegacyReport = {
	id: string;
	numItems: number;
	numericId: number;
	score: number;
	sessionDate: string;
};

export type ExamStatus =
	| "COMPLETE"
	| "ACTIVE"
	| "NOT_STARTED"
	| "LEGACYREPORT"
	| "MIGRATEDREPORT";
export type PracticeTestExam = {
	id: string;
	title: string;
	numItems: number;
	numCompleted: number;
	itemIds?: number[];
	status?: ExamStatus;
	icon?: string;
	totalTime: number;
	numericId?: number;
	dateCompleted: string;
	timeElapsed: number;
	distribution: Distribution;
	attempted: Distribution;
	hasAccess?: boolean;
	type: "PRACTICE_TEST" | "QUIZ";
	legacyReport?: LegacyReport;
	migratedSessionReport?: LegacyReport;
	beginStartDate?: string;
	endStartDate?: string;
};
type MixedItemDist = {
	iconUrl: string;
	title: string;
	contents: Content[];
	freeTagIds: string[];
	tags: MixedItemTag[];
	exams?: PracticeTestExam[];
	hasAccess?: boolean;
	accuracy?: number;
	speed?: number;
	numPointsEarned?: number;
	numTotalPoints?: number;
};

type MixedItemDistResponse = MixedItemDist;

type TagsByType = Record<string, MixedItemTag[]>;
export type { MixedItemDist, MixedItemDistResponse, MixedItemTag, TagsByType };
